import React from 'react';
import './container.scss';

const BoxContainer = (props) => {
  return (
    <div className='boxContainer'>
        {props.children}
    </div>
  )
}

export default BoxContainer